import { useState } from "react";
import newRequest from "../../utils/newRequest";

const UploadChat = () => {
    const [file, setFile] = useState(null);
    const [prompt, setPrompt] = useState("");
    const [responses, setResponses] = useState([]);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Please upload a file first.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const uploadResponse = await newRequest.post("/upload", formData);
            console.log("Upload Response:", uploadResponse.data);
            alert("File uploaded successfully!");
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("An error occurred while uploading the file.");
        }
    };

    const handleChat = async () => {
        if (!prompt) {
            alert("Please enter a prompt.");
            return;
        }

        try {
            const chatResponse = await newRequest.post("/chat", { prompt });
            const { response } = chatResponse.data;

            setResponses((prev) => [...prev, { prompt, response }]);
            setPrompt("");
        } catch (error) {
            console.error("Error interacting with ChatGPT:", error);
            alert("An error occurred while chatting.");
        }
    };

    return (
        <div style={{ maxWidth: "600px", margin: "auto" }}>
            <h1>Upload Document & Chat</h1>
            <input type="file" accept=".pdf,.doc,.docx" onChange={handleFileChange} />
            <button onClick={handleUpload}>Upload</button>
            <hr />
            <textarea
                placeholder="Enter your prompt here"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={4}
                style={{ width: "100%", marginTop: "10px" }}
            />
            <button onClick={handleChat} style={{ marginTop: "10px" }}>
                Send Prompt
            </button>
            <div style={{ marginTop: "20px" }}>
                <h2>Responses</h2>
                {responses.map((res, index) => (
                    <div key={index} style={{ marginBottom: "15px" }}>
                        <strong>Prompt:</strong>
                        <p>{res.prompt}</p>
                        <strong>Response:</strong>
                        <p>{res.response}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UploadChat;
